import styled from "styled-components";

// Constants
import colors from "../../../../css/colors";

export const SectionCard = styled.div`
  display: flex;
  flex: 1;
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
  padding: 24px;
  max-width: 100%;
  overflow-x: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:last-child) {
    margin: 0 0 16px;
  }
`;

interface LabelProps {
  margin?: string;
}

export const Label = styled.span<LabelProps>`
  margin: ${(props) => (props.margin ? props.margin : "initial")};
  min-width: 156px;
  font-weight: 600;
  font-size: 12px;
  text-align: right;

  @media screen and (max-width: 425px) {
    width: min-content;
  }
`;

interface CheckboxWrapperProps {
  disabled?: boolean;
}

export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  display: flex;
  align-items: center;
  padding: 8px 0 8px 8px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  min-width: 120px;
  background-color: ${(props) => (props.disabled ? colors.GREY_BACKGROUND : "initial")};

  &:not(:last-child) {
    margin: 0 24px 0 0;
  }
`;

interface InputWrapperProps {
  maxWidth?: number;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  flex: 1;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : "inherit")};

  &:not(:last-child) {
    margin: 0 24px 0 0;
  }

  .ant-input-number {
    width: 100%;
  }

  textarea {
    resize: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 24px 0 0;
  padding: 24px 16px;
  min-width: 288px;
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 6px;
  background-color: #fbfbfb;

  @media screen and (max-width: 320px) {
    min-width: 248px;
  }

  @media screen and (min-width: 1240px) {
    margin: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 0 0 16px;
  color: ${colors.GREY_DARK};
  font-size: 16px;
  font-weight: 700;
`;

export const Body = styled.div`
  color: ${colors.GREY};
  font-size: 12px;
  font-weight: 600;

  &:not(:last-child) {
    margin: 0 0 8px;
  }
`;
